import React from 'react';

import { TextButton } from 'components/uiLibrary/LinkButton';
import SpriteIcon from 'components/uiLibrary/SpriteIcon';
import Typography from 'components/uiLibrary/Typography';

import { SUB_COMPONENTS } from 'components/Globals/Analytics/constants';
import CastingToolPromo from 'components/Globals/CastingToolPromo';

import { TP } from 'constants/index';

import { useTranslation } from 'src/i18n';

import classes from './SectionTitle.module.scss';

const TitleWithLink = ({ title, linkProps, withLink = true, hideViewAll = false, trackingData = {} }) => {
  const { t } = useTranslation('NS_APP_GLOBALS');

  if (withLink) {
    return (
      <TextButton
        styles={{ root: classes.link }}
        {...linkProps}
        rightIcon={<SpriteIcon icon="chevron_right" size={18} />}
        disableHover
        disableUnderline
        isLink
        trackingData={{
          ...trackingData,
          subComponent: SUB_COMPONENTS.NAVIGATE_CTA,
        }}
      >
        <TitleWithLink linkProps={linkProps} withLink={false} title={title} />
        {!hideViewAll && (
          <Typography className={classes.link_viewAll} size={12} weight="bold" color="link">
            {t(`${TP}.VIEW_ALL`)}
          </Typography>
        )}
      </TextButton>
    );
  }

  return (
    <Typography variant="h2" size={16} weight="bold" className={classes.title}>
      {title}
    </Typography>
  );
};

const SectionTitle = ({ title, linkProps, withActions, hideViewAll = false, trackingData = {} }) => (
  <div className={classes.root}>
    <TitleWithLink
      linkProps={linkProps}
      withLink={!!linkProps}
      title={title}
      hideViewAll={hideViewAll}
      trackingData={trackingData}
    />

    <div className={classes.actions}>{withActions && <CastingToolPromo asCTA trackingData={trackingData} />}</div>
  </div>
);

export default SectionTitle;
